import { useMemo } from 'react';
import { useIteamResource } from '../../../hook/ShowTable/generic';
import { ApiGeneralItem, ApiGeneralResponse } from '../config/type';
import { normalizeRows } from '../utils/normalizeRows';

export function useGeneralData(generalUrl?: string) {
  const { data, loading, error, refetch } =
    useIteamResource<ApiGeneralResponse | ApiGeneralItem[]>(generalUrl, undefined, Boolean(generalUrl));

  const rows = useMemo(() => normalizeRows(data), [data]);
  return { rows, loading, error, refetch };
}
